import _ from 'lodash';

export class ImageCollection {
    public list: any[] = [];

    public status: number = 0;
    public remaining: number = 0;
    public uploaded: number = 0;

    public index: number = 0;

    public get length() {
        return this.list.length;
    }

    public addImage(image) {
        const error = _.get(image, 'error', null);
        if(_.isString(error)) {
            return false;
        }

        this.list.push(image);
        this.remaining++;

        return true;
    }

    public addImageList(images) {
        _.forEach(images, image => {
            image.imageUrl = null;
            return this.addImage(image);
        })
    }

    public reset() {
        this.list = [];

        this.status = 0;
        this.remaining = 0;
        this.uploaded = 0;
    }
}